import { IMarketYoyGrowthUserInfoApi } from '../api/types'
import { IMarketYoyGrowthUserInfo } from '../model/types'

export const mapMarketYoyGrowthUserInfoFromApi = (
  data: IMarketYoyGrowthUserInfoApi
): IMarketYoyGrowthUserInfo => ({
  market: data.Market,
  userId: data.UserID,
  viewType: data.ViewType,
})
